function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import * as React from 'react';
import classnames from 'classnames';
import handleEvent from '../libs/handleEvent';
import injectStyles from '../jss';
import styles from './RadioInput.jss';
import Tooltip from '../Tooltip';
export var RadioInput = /*#__PURE__*/
function (_React$PureComponent) {
  _inherits(RadioInput, _React$PureComponent);
  function RadioInput() {
    var _getPrototypeOf2;
    var _this;
    _classCallCheck(this, RadioInput);
    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }
    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(RadioInput)).call.apply(_getPrototypeOf2, [this].concat(_args)));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleRadioInputChange", function () {
      var _this$props = _this.props,
        name = _this$props.name,
        onChange = _this$props.onChange;
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      handleEvent.apply(void 0, [name, onChange].concat(args));
    });
    return _this;
  }
  _createClass(RadioInput, [{
    key: "renderInput",
    value: function renderInput() {
      var _this$props2 = this.props,
        classes = _this$props2.classes,
        name = _this$props2.name,
        selected = _this$props2.selected,
        value = _this$props2.value;
      return React.createElement("input", {
        checked: selected,
        className: classes.input,
        key: "input",
        name: name,
        onChange: this.handleRadioInputChange,
        type: "radio",
        value: value
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        classes = _this$props3.classes,
        vertical = _this$props3.vertical,
        text = _this$props3.text,
        selected = _this$props3.selected,
        tooltip = _this$props3.tooltip,
        value = _this$props3.value,
        error = _this$props3.error;
      var optionText = text || value;
      return React.createElement("label", {
        className: classnames(classes.wrapper, vertical && classes.wrapper__vertical)
      }, React.createElement("div", {
        className: classnames(classes.base, selected && classes.base__selected, error && classes.base__error)
      }), this.renderInput(), React.createElement("div", {
        className: classes.optionText
      }, optionText), React.createElement(Tooltip, {
        tooltip: tooltip,
        size: 16
      }));
    }
  }]);
  return RadioInput;
}(React.PureComponent);
_defineProperty(RadioInput, "styleRoot", 'RadioInput');
export default injectStyles(styles)(RadioInput);